export default __webpack_public_path__ + "static/media/form_bg.117ace50.png";